<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template slot="left">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :row-data="rowData"
          :show-side-bar="false"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          min-height="100%"
          class="section"
          grid-style="min-width: 160px;width:100%;height:100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <!--返回-->
                  <el-button type="primary" no="1" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <!--编辑-->
                  <el-button :disabled="!(job && Number(job.jobState) === 0 && !JobUtils.isBlockJob(job))" type="success" no="2" @click="editHandler('edit')">{{ $t('common.btn.edit') }}</el-button>
                  <!--重新编辑-->
                  <el-button v-show="($checkPermission(['button_SEDocuments_reEdit']) || $store.getters.isAdmin) && (job && Number(job.jobState) > 0)" type="success" no="3" @click="editHandler('editAgain')">{{ $t('common.btn.editAgain') }}</el-button>
                  <!--打印-->
                  <el-button :disabled="enablePrint" type="success" no="4" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
                </div>
                <div v-show="action==='edit'" style="border-left:none;padding-left:0">
                  <!--保存-->
                  <el-button type="success" no="5" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <!--取消-->
                  <el-button type="success" no="6" @click="cancelEdit(()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
                  <!--保存默认值-->
                  <el-button type="primary" no="7" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'||action==='edit'" style="display: flex; white-space:nowrap;">
                <el-tooltip effect="dark" :content="$t('SeaExport.Tip2')" placement="bottom-start">
                  <img :src="locationImg" style="width: 20px;margin-right: 5px;" no="8" @click="toQueryDataPushLog">
                </el-tooltip>
                <el-tooltip effect="dark" :content="action==='edit' ? '' : $t('SeaExport.Tip1')" placement="bottom-start" :offset="sopTooltipOffset" :visible-arrow="false">
                  <div style="width: 100%;cursor: pointer" no="9" @mousemove="resetSopTooltip" @dblclick="onBtnListDoubleClicked()">
                    <span class="red" style="font-size:14px;padding:5px 0">{{ commonInfo.jobState }}</span>
                    <span style="font-size:12px;padding: 5px 9px;color:unset;" v-html="commonInfo.jobTitle" />
                    <span class="red" style="font-size:12px;padding:5px 0">{{ commonInfo.jobLock }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && (masterFlag || paramsOfTab.signMBL) && privilege.seBooking.mbl"
                :key="1"
                :lazy="true"
                name="tabMBL"
                label="MB/L"
              >
                <tab-mbl ref="tabMBL" :context="context" :action="action" @resetTab="resetTab" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && privilege.seBooking.mbl2 && (paramsOfTab.typeMBL !== 0 && paramsOfTab.typeMBL !== 1)"
                :key="2"
                :lazy="true"
                name="tabMBL2"
                :label="'MB/L'+(paramsOfTab.typeMBL===2?$t('CargoMsg.Cargo_SplitBL'):'')+(paramsOfTab.typeMBL===3?$t('SeaExport.MergeAndSingle'):'')"
              >
                <tab-mbl2 ref="tabMBL2" :context="context" :action="action" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.signHBL && !paramsOfTab.mblOnly && !masterFlag && privilege.seBooking.hbl"
                :key="3"
                :lazy="true"
                name="tabHBL"
                label="HB/L"
              >
                <tab-hbl ref="tabHBL" :context="context" :action="action" @resetTab="resetTab" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !paramsOfTab.mblOnly && !isNew && privilege.seBooking.hbl2 && (paramsOfTab.typeHBL !== 0 && paramsOfTab.typeHBL !== 1)"
                :key="4"
                :lazy="true"
                name="tabHBL2"
                :label="'HB/L'+(paramsOfTab.typeHBL===2?$t('CargoMsg.Cargo_SplitBL'):'')+(paramsOfTab.typeHBL===3?$t('SeaExport.MergeAndSingle'):'')"
              >
                <tab-hbl2 ref="tabHBL2" :context="context" :action="action" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && paramsOfTab.ams && !masterFlag && privilege.seBooking.ams"
                :key="5"
                :lazy="true"
                name="tabAMS"
                label="AMS/ENS"
              >
                <tab-ams ref="tabAMS" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && privilege.seBooking.containersLayer"
                :key="6"
                :lazy="true"
                name="tabContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-container ref="tabContainer" :context="context" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && masterFlag && !isNew && privilege.seBooking.lclManagerLayer"
                :key="7"
                :lazy="true"
                name="tabLclContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-lcl-container
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  view-source="salesDetail"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 数据推送变更记录弹窗 -->
    <el-dialog
      v-if="dataPushDialog.visible"
      v-el-drag-dialog
      :visible.sync="dataPushDialog.visible"
      :title="$t('SeaExport.DataPushChangeLog')"
      width="580px"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="dataPushDialog.visible=false"
    >
      <div
        class="app-main-inner-row"
        style="padding: 0;display: flex;flex-direction: column"
        :style="{width:'100%',height:'400px',overflow:'auto'}"
      >
        <div v-for="(title,index) in dataPushDialog.titles" :key="index">
          <div style="background:#EBECF5">
            <b>{{ title }}</b>
          </div>
          <div v-for="(item,index) in dataPushDialog.dataMap.get(title)" :key="index">
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- SOP操作状态弹窗 -->
    <sop-state-dialog :hide-window="isEditing" :visible.sync="sopStateDialog.visible" :is-need-refresh.sync:="sopStateDialog.isNeedRefresh" :default-is-expand="sopStateDialog.defaultIsExpand" :job="job" :is-need-expand.sync="sopStateDialog.isNeedExpand" @handleClose="sopStateDialogClose" />
  </div>
</template>

<script>
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import { DocumentWorkspaceContext } from './documentWorkspaceContext'
import { DocumentWorkspacePM } from './documentWorkspacePM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import tabMbl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL'
import tabMbl2 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabMBL2'
import tabHbl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL'
import tabHbl2 from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL2'
import tabAms from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabAMS'
import tabContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabContainer'
import tabLclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainer'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import { TabError } from '@/utils/class/TabError'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { documentSave } from '@/api/seaExport/seaExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { Company } from '@/class/model/mdm/Company'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { ensureExecuteSuccess, deepCopy, sleep } from '@/utils/commonUtil'
import { sortByMultiField } from '@/utils'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import TabDataTracking from '@/views/cargo/v0/SeaExport/components/booking/tabs/TabDataTracking'
import locationImg from '@/assets/location24.png'
import { getLoading } from '@/utils/utilBaseElement'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'

export default {
  name: 'DocumentWorkspace',
  components: {
    CargoButtonGroupSlider,
    TabDataTracking, DropUploader, cargoAdvanceSelect, cargoLeftRightResize, cargoTemplateSelectorDialog,
    tabMbl, tabMbl2, tabHbl, tabHbl2, tabAms, tabContainer, tabLclContainer, EstimateValidationDialog, sopStateDialog
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      JobUtils,
      locationImg,
      URL,
      selectTypeNames: TYPE_NAMES,
      context: new DocumentWorkspaceContext(this.parentContext),
      pm: new DocumentWorkspacePM(this),
      SystemConstants,
      privilege: {
        seBooking: {
          mbl: this.$checkPermission(['tab_SEBooking_MBL']),
          mbl2: this.$checkPermission(['tab_SEBooking_MBL2']),
          hbl: this.$checkPermission(['tab_SEBooking_HBL']),
          hbl2: this.$checkPermission(['tab_SEBooking_HBL2']),
          ams: this.$checkPermission(['tab_SEBooking_AMS']),
          containersLayer: this.$checkPermission(['tab_SEBooking_ContainersLayer']),
          lclManagerLayer: this.$checkPermission(['tab_SEBooking_LclManagerLayer'])
        }
      },
      commonInfo: {
        jobState: '',
        jobTitle: '',
        jobChangeState: '',
        jobLock: ''
      },
      sopTooltipOffset: 0,
      enablePrint: false, // 打印按钮是否可用
      action: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 160,
          tooltip: (params) => {
            return params.data ? params.data.jobNo : ''
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob && currentJob.dataType && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:2px;" />${params.value}</span>`
              }
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onRowClicked: this.changeJob
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      template: {}, // 跨tenant委托后调用模板，上传到云存储
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'SE',
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => {}
      },
      dataPushDialog: {
        visible: false,
        titles: [],
        dataMap: new Map()
      },
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      isGetNewJobInfoFromDb: false, // 是否从数据库里获取最新job相关信息【暂时用于保存之后取job】
      isOtherEdit: false // 拆分主票，复制业务，都属于新增的数据，uuid为空，但是大部分字段已经有值，不需要走初始化数据操作
    }
  },
  computed: {
    user() {
      return this.context.user
    },
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    job() {
      return this.currentRow
    },
    sideBar() {
      return this.$store.getters.sidebar.opened
    }
  },
  async created() {
    await this.context.prepareData()
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.enablePrint = false
      this.loading = getLoading()
      this.selectedRow = selectedRow
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      this.action = action
      if (!this.activeTabName) {
        this.paramsOfTab.masterFlag = this.currentRow.masterFlag = selectedRow.masterFlag
      }
      this.isOtherEdit = action === 'split' || action === 'copy'
      this.action = action
      if (selectedRow.uuid) {
        this.rowData = rowData
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.loading.close()
        await this.onRowClicked({ data: selectedRow })
      })
      if (action === 'look') {
        const cfg = LocalStorageUtils.getConfiguration('SESopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
      }
    },
    /**
     * 正本打印锁定业务页签
     */
    async lockBookingTab() {
      const job = this.job
      const hbl = await new SeaExportJob(job).getMainHbl()
      job.printHblZbLock = false
      const isLockTab = await parseInt(this.config.get('HBLPrintLockTab')) === 1
      if (hbl) {
        job.printHblZbLock = (hbl.state === 2 && isLockTab)
      }
    },
    // sop 双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    // sop 关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('SESopStatusPopupVisible', false)
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getModel().rowsToDisplay
      this.gridApi.clearFocusedCell()
      // this.$logger.log('nodes', nodes)
      // this.$logger.log('this.rowData', this.rowData)
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid || item.data.jobUuid
        const rowKey = row.uuid || row.jobUuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    },
    // 左侧列表切换job
    async changeJob(event) {
      const result = event.data
      if (result) {
        // 重新数据库中加载job
        this.isGetNewJobInfoFromDb = true
        result.version = 0
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        await this.onRowClicked({ data: result })
        // console.log('changeJob====', event.data, event.data.seaEQ, event.data.lclSlaves)
      }
    },
    // 行点击
    async onRowClicked(event) {
      this.loading = getLoading()
      if (!event.data) {
        this.loading.close()
        return
      }
      let job = event.data
      const jobVersion = job.version
      // 若选中提单拆并单,则需要找到其父级job
      if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === job.jobUuid) {
            job = item
            break
          }
        }
      }
      this.setGridSelect(job)
      // 加载job详细信息
      if (!job.isCompleteRow || this.isGetNewJobInfoFromDb) {
        const jobModel = new SeaExportJob(job)
        if (job.uuid) {
          if (!jobVersion || jobVersion === 0) job.version = 0 // version为0时可以重新加载job
          await jobModel.loadJobRelated({
            job: !(jobModel.version >= 1), // 脏数据，需要重新载入
            seaEQ: true,
            lclSlaves: job.masterFlag,
            charges: true,
            warehouseIn: true,
            warehouseInfo: true,
            trucking: true,
            lclMaster: !job.masterFlag,
            seaCargoDoc: !job.masterFlag,
            containerUsages: true,
            containers: true,
            cargoBulkDetail: !job.masterFlag,
            surchargeTerms: !job.masterFlag
          })
          // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
          if (!jobModel.masterFlag) {
            ContainerUtil.buildContainerUsages(job)
          }

          if (!job.path) {
            this.setBasicData(job)
            this.gridApi.refreshCells({ force: true })
          }
        } else {
          jobModel.seaEQ = jobModel.seaEQ || []
          jobModel.lclSlaves = jobModel.lclSlaves || []
          jobModel.charges = jobModel.charges || []
          jobModel.warehouseIn = jobModel.warehouseIn || []
          jobModel.warehouseInfo = jobModel.warehouseInfo || []
          jobModel.trucking = jobModel.trucking || []
          jobModel.seaCargoDoc = jobModel.seaCargoDoc || []
          jobModel.containerUsages = jobModel.containerUsages || []
          jobModel.containers = jobModel.containers || []
          jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
          jobModel.surchargeTerms = jobModel.surchargeTerms || []
        }
        job.isCompleteRow = true
        this.isGetNewJobInfoFromDb = false
        // console.log('onRowClicked====', this.currentRow, this.currentRow.seaEQ, this.currentRow.lclSlaves)
      }
      this.currentRow = job
      this.initInfo()
      await this.lockBookingTab()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.$nextTick(() => {
        if (this.isNew) {
          this.activeTabName = this.getDefaultActiveName()
        } else {
          const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
          if (activePanes && activePanes.length === 0) {
            this.activeTabName = this.getDefaultActiveName()
          }
        }
        this.handleTabClick()
      })
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理（在编辑状态下）
    async endTabHandler(tabName) {
      if (this.action === 'look') {
        return
      }
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.loading = getLoading()
      // CARGO-9583 详情打印控件应置灰处理
      const tabs = ['tabTradeDetail', 'tabTradeCommission', 'tabAdvanceCharge', 'tabSopState', 'tabFileHistory', 'tabFile']
      this.enablePrint = tabs.includes(this.activeTabName)
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        // this.$logger.log('handleTabClick-isRefresh', isRefresh)
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
        this.loading.close()
      })
    },
    // 编辑、重新编辑走这里
    async editHandler(action) {
      this.loading = getLoading()
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 150)
      }).then(async() => {
        if (action !== 'editAgain') { // 重新编辑不需要验证
          if (this.currentRow.jobState !== 0) {
            this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
            this.loading.close()
            return
          }
          if (!await this.checkCanEdit(this.currentRow)) {
            this.loading.close()
            return
          }
        }
        this.againShow('edit')
      })
    },
    async checkCanEdit(row) {
      if (this.$store.getters.isAdmin) return true
      const userId = this.$store.getters.userId
      if (row && (row.dc === userId || row.op === userId)) {
        return true
      }
      if (this.$checkPermission(['role_editAllBusiness'])) {
        return true
      }
      if (this.$checkPermission(['role_DepartmentEdit'])) {
        const flag = await SecurityUtil.hasSpecificDepartmentEdit(row, { 'op': true, 'dc': true })
        if (!flag) {
          this.$message.warning(this.$t('Message.NotGroupBusinessesCannotBeEdit'))
          return false
        } else {
          return true
        }
      }
      this.$message.warning(this.$t('Message.DocumentEditedTips'))
      return false
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      this.loading = getLoading()
      const selectedRow = this.isNew ? row || {} : this.currentRow
      this.onShow(action, this.rowData, selectedRow)
    },
    // 保存海运业务【保存业务相关数据】
    async save() {
      this.loading = getLoading('app-main-content')
      // 当前页签结束后的处理
      if (this.activeTabName) {
        await this.endTabHandler(this.activeTabName)
      }
      const body = {}
      try {
        for (const item of [...this.pendTabSet, 'other']) {
          let tabData = null
          if (item !== 'other') {
            // 各页签的保存数据
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              /* 获取各页签需要保存的数据 */
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
            }
          } else {
            // 被联动修改了的数据
            tabData = this.context.modifiedData
          }

          if (!tabData) continue
          // this.$logger.log('tabData' + item, tabData)
          // 将不同页签相同key的集合进行数据合并
          for (const key in tabData) {
            const tabValue = tabData[key]
            // this.$logger.log('tabValue：' + item, tabValue)
            if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
            const bodyValue = body[key]
            // this.$logger.log('bodyValue：' + item, bodyValue)
            if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
            // 将数组进行合并
            if (Array.isArray(tabValue)) {
              //
              if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                const bodyMap = new Map()
                if (bodyValue && bodyValue.length > 0) {
                  for (const bodyKey of bodyValue) {
                    if (!bodyKey) continue
                    if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                  }
                }
                if (tabValue && tabValue.length > 0) {
                  for (const tabKey of tabValue) {
                    if (!tabKey || bodyValue.includes(tabKey)) continue
                    if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                    bodyValue.push(tabKey)
                  }
                }
              } else {
                tabValue.push(bodyValue)
                body[key] = tabValue
              }
              delete tabData[key]
            }
          }
          Object.assign(body, tabData)
          // this.$logger.log('页签名称：' + item, tabData)
        }

        // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
        if (Reflect.has(body, 'job') && body.job) {
          for (const key in body.job) {
            // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
            if (typeof body.job[key] === 'object') delete body.job[key]
          }
        }
        this.cleanCircleObject(body)
      } catch (err) {
        this.loading.close()
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }

      // 主票没有HBL,这里传HBL到后端进行修改，引起报错
      if (body.job && body.job.masterFlag && body.seaCargoDoc && body.seaCargoDoc.length > 0) {
        for (const cargoDoc of body.seaCargoDoc) {
          if (cargoDoc.docType === 'HBL') {
            const index = body.seaCargoDoc.indexOf(cargoDoc)
            if (index > -1) body.seaCargoDoc.splice(index, 1)
          }
        }
      }
      this.$logger.log('body', body)
      try {
        // 在保存前进行校验
        if (!(await this.pm.checkBeforeSave())) {
          this.loading.close()
          return
        }
      } catch (err) {
        this.loading.close()
        throw err
      }

      // 后端触发SOP使用
      if (!this.isNew) body.jobUuid = this.job.uuid

      // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
      await SopUtil.checkSopTemplate(body.job, this)
      // 保存 访问数据库
      // 拆分主票 保存处理逻辑【也走这里】
      body.action = this.action
      await documentSave(body).then(res => {
        const result = res.data
        if (result) {
          Object.assign(this.currentRow, result)
          this.currentRow.version = 0
          this.currentRow.blocked = result.blocked
          this.currentRow.jobUuid = result.uuid
          this.currentRow.dataType = result.masterFlag ? 1 : 2 // 1、主票 1、小票
          if (this.currentRow.lclMasterUuid) {
            this.currentRow.path = result.lclMasterUuid + ',' + result.uuid
          } else {
            this.currentRow.path = result.uuid
          }
          this.isRefresh = true
        }
        this.updateCargoDocNo(body.seaCargoDoc)
        // 重置子表数据【将job相关信息置空，然后从库里重新加载】
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        this.currentRow.isCompleteRow = false
        const lclSlaves = body.lclSlaves // 先将拆分主票对应的小票记录，保存后使用
        if (this.action === 'split' && lclSlaves && lclSlaves.length > 0) {
          if (!this.currentRow.beSplitedLclUuids) {
            this.currentRow.beSplitedLclUuids = Array.from(lclSlaves, p => p.uuid)
          }
          // 原被拆分的主票uuid集合
          const oldMasterUuidSet = new Set()
          // 更新小票
          const rows = this.rowData.filter(p => this.currentRow.beSplitedLclUuids.includes(p.uuid))
          for (const lcl of rows) {
            oldMasterUuidSet.add(lcl.lclMasterUuid)
            lcl.isCompleteRow = false
            lcl.parentUuid = this.currentRow.uuid
            lcl.lclMasterUuid = this.currentRow.uuid
            lcl.path = this.currentRow.uuid + ',' + lcl.uuid
            lcl.version = 0 // 标识为脏数据，需要重新载入
          }
          this.gridApi.setRowData(this.rowData)
          // 原被拆分的主票，需重新加载
          const oldMasterJobs = this.rowData.filter(p => oldMasterUuidSet.has(p.uuid))
          for (const item of oldMasterJobs) {
            item.isCompleteRow = false
            item.version = 0 // 标识为脏数据，需要重新载入
            // 重置子表数据
            for (const key in item) {
              if (typeof item[key] === 'object') {
                item[key] = ''
              }
            }
          }
        }
      }).finally(() => {
        this.loading.close()
      })

      // 保存成功后各业签执行的回调方法
      for (const item of this.pendTabSet) {
        const executeTask = this.$refs[item].executeTask
        if (executeTask && typeof executeTask === 'function') {
          /* 保存成功后的回调 */
          const result = this.$refs[item].executeTask()
          if (result instanceof Promise) {
            await result
          }
        }
      }
      this.isGetNewJobInfoFromDb = true
      await this.againShow('look', this.currentRow)
      if (JobUtils.isBlockJob(this.currentRow)) {
        // 保存成功之后如果是信控锁住则会弹此提示【Job.as 中的 save方法】
        setTimeout(() => {
          this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
        }, 2000)
      }
      this.$message.success(this.$t('Message.SaveSuccessfully'))

      // 保存业务触发SOP后需要刷新 SOP操作状态弹框
      if (this.sopStateDialog.visible) {
        setTimeout(() => {
          this.sopStateDialog.isNeedRefresh = true
        }, 3000)
      }
    },
    // 更新MBL、HBL拆单编号
    updateCargoDocNo(seaCargoDoc) {
      if (!seaCargoDoc) {
        return
      }
      for (const item of seaCargoDoc) {
        if (!item.uuid) {
          continue
        }
        if (item.docType === CargoDocConsts.MBL2) {
          const row = this.rowData.find(p => p.uuid === item.uuid)
          if (row) {
            row.jobNo = item.mblNbr2
          }
        } else if (item.docType === CargoDocConsts.HBL2) {
          const row = this.rowData.find(p => p.uuid === item.uuid)
          if (row) {
            row.jobNo = item.hblNbr2
          }
        }
      }
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    // 保存默认值
    saveDefaultVal() {
      this.loading = getLoading()
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'SeaExportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 刷新
    refresh() {
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.job)
    },
    // 加载完job走这里
    initInfo() {
      this.showJobState()
      this.showJobTitle()
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.jobState = ''
        this.commonInfo.jobLock = ''
        this.commonInfo.jobChangeState = ''
        return
      }
      this.commonInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      this.commonInfo.jobLock = JobUtils.isBlockJob(this.currentRow) ? this.$t('Message.Locked') : ''
      // 改单状态
      if (Number(this.config.get('IsCommittedAllowAddCost')) === 1) {
        this.commonInfo.jobChangeState = ColumnUtils.getJobChangeState(this.currentRow)
      }
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = job.jobNo
      if (parseInt(job.customerId) > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await new Company(cmp).getCustomerDetail().then(data => {
            if (data) {
              const str1 = ` ${this.$t('Message.BillingType')}[${this.$t('Message.ByTicket')}]`
              const str2 = `${this.$t('Message.BillingType')}[${this.$t('Message.Monthly')}]`
              return data.invoiceMode === 0 ? str1 : str2
            }
            return ''
          })
          jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + cmp.chineseName + creditTerm + '</span><span>' + billingType + '</span>'
        }
      }
      this.commonInfo.jobTitle = jobTitle
    },
    // 数据推送日志
    async toQueryDataPushLog() {
      this.loading = getLoading()
      await new SeaExportJob(this.job).loadPushHistoryLogs()
      this.loading.close()
      const item = this.job.pushHistoryLogs
      this.dataPushDialog.titles = []
      this.dataPushDialog.dataMap = new Map()
      if (item) {
        const dataArr = []
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k] })
        }
        // 排序 按时间降序
        sortByMultiField(dataArr, ['time'], true)
        if (dataArr && dataArr.length > 0) {
          for (const data of dataArr) {
            const logs = data.logs
            const firstLog = logs[0]
            let t = '：' + this.$t('SeaExport.DataPush')
            if (Number(firstLog.sourceType) === 1) {
              t = '：' + this.$t('SeaExport.MasterTicketSync')
            } else if (Number(firstLog.sourceType) === 2) {
              t = '：G7' + this.$t('SeaExport.DataPush')
            }
            const labTime = new Date(Number(data.time))
            const title = DateUtils.formatStandardDateTime(labTime) + t
            this.dataPushDialog.titles.push(title)
            const cMap = {}
            let labLog = ''
            const titleVals = []
            for (const h of logs) {
              if (!cMap.hasOwnProperty(h.fieldName + h.targetValue)) {
                if (!h.sourceValue || h.targetValue === h.sourceValue) {
                  labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_NewValue') + '->' + h.targetValue
                } else {
                  //
                  const newValArr = h.targetValue ? h.targetValue.split(' ') : []
                  labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_OriginalValue') + '->' + h.sourceValue + this.$t('CargoMsg.Cargo_NewValue') + '->' + (newValArr && newValArr.length > 0 ? newValArr[0] : '')
                  if (newValArr && newValArr.length > 0) {
                    for (const str of newValArr) {
                      const index = newValArr.indexOf(str)
                      if (index > 0) titleVals.push(str)
                    }
                  }
                }
                // 每一行便是一个div[ labLog -> div]
                titleVals.push(labLog)
              }
              if (h.fieldName === '箱种' || h.fieldName === this.$t('SeaExport.ContainerSize')) {
                cMap[h.fieldName + h.targetValue] = h.fieldName + h.targetValue
              }
            }
            this.dataPushDialog.dataMap.set(title, titleVals)
          }
        }
      }
      this.dataPushDialog.visible = true
    },
    // 返回
    goBack() {
      this.activeTabName = ''
      this.action = ''
      this.$store.dispatch('app/setCanCloseModule', true)
      this.$emit('back', this.isRefresh)
    },
    // 打印
    onPrint() {
      if (JobUtils.isBlockJob(this.job)) {
        this.$message.info(this.job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
        return
      }
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.job.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    resetSopTooltip(event) {
      this.sopTooltipOffset = event.offsetX
    },
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    reload() {
      this.currentRow.version = 0
      this.isRefresh = true
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.currentRow)
    }
  }
}
</script>
